export const updateSearchFiltersAndRedirect = (city: string) => {
  const searchFilters = JSON.parse(
    localStorage.getItem('searchFilters') || '{}',
  )

  searchFilters.iLiveIn = [city]

  localStorage.setItem('searchFilters', JSON.stringify(searchFilters))

  window.location.href = '/'
}
